(self["webpackChunkgom_well_analysis"] = self["webpackChunkgom_well_analysis"] || []).push([[461],{

/***/ 4050
() {



/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(4050));
/******/ }
]);